import { gql } from '@parkchirp/api-client';

export const REASSIGN_PRIMARY_CONTACT = gql`
  mutation reassignPrimaryContact(
    $level: ReassignPCLevelEnum!,
    $payor: PayorInput!,
    $subscriptionId: String!,
    $newEmail: String!,
    $newCognitoSub: String,
    $newWordpressUserId: Int,
    $invoiceRecipients: [String!]
  ) {
    reassignPrimaryContact(
      level: $level,
      payor: $payor,
      subscriptionId: $subscriptionId,
      newEmail: $newEmail,
      newCognitoSub: $newCognitoSub,
      newWordpressUserId: $newWordpressUserId      
      invoiceRecipients: $invoiceRecipients
    )
  }
`;

export const UPDATE_PAYOR = gql`
  mutation updatePayor(
        $payor: UpdatePayorInput!,
        $tenantSubscriptionId: String
    ) {
        updatePayor(
            payor: $payor,
            tenantSubscriptionId: $tenantSubscriptionId
        ) {
            id
        }
    }
`;

export const CREATE_LEASES_FIRST_MONTH_INVOICES = gql`
  mutation createLeasesFirstMonthInvoices(
    $subscriptionId: String!
    $months: [String!]!
  ) {
    createLeasesFirstMonthInvoices(
      subscriptionId: $subscriptionId
      months: $months
    )
  }
`;
